'use strict';

exports.__esModule = true;
exports.putRequest = putRequest;

var _pipeline = require('../pipeline');

var _pipeline2 = _interopRequireDefault(_pipeline);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function putRequest(method, url, opts) {
  var addr = new URL(url);
  var uri = addr.host + addr.pathname;
  _pipeline2['default'].put('requests/' + uri, { method: method, url: url, opts: opts });
}


/*****************
 ** WEBPACK FOOTER
 ** ./~/data-pipeline/lib/ajax/utils.js
 ** module id = 65
 ** module chunks = 0
 **/